import { Link } from "react-router-dom";

const stats = [
  { value: "14+", label: "深度资讯" },
  { value: "5", label: "核心分类" },
  { value: "4", label: "文化专题" },
  { value: "100%", label: "原创解读" },
];

export default function AboutIntro() {
  return (
    <section className="bg-background-100/60 border-y border-background-200">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-accent-600">ABOUT PLATFORM</span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-snug">
              以内容权威性与文化深度为核心
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              「黑人」是一个聚焦黑人文化、历史、艺术与社会动态的综合性资讯平台。我们通过深度报道、专题聚合与多维度分类，帮助文化爱好者、学者、学生与从业者，系统化地理解一个丰富而复杂的文化世界。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们相信，真正的理解始于准确的讲述。每一篇内容都力求兼顾学术严谨与阅读体验，让知识既可靠，也动人。
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-4">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始探索
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {stats.map((item) => (
              <div
                key={item.label}
                className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-7"
              >
                <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">
                  {item.value}
                </span>
                <p className="mt-2 text-sm text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}